import { freeMsg, t } from '../../../common/i18n';
import { DeliveryModeType } from '../placeOrderTypes.js';
import type { DeliveryMethodGroup } from '../../../generated/api/deliveryMethodGroup.js';
import type { ProductOfferingCoco } from '../../../generated/api/productOfferingCoco.js';

export const DELIVERY_GROUP_IDS = {
  DIRECT: 'Direct_Delivery_Shipping',
  INDIRECT: 'Indirect_Delivery_Shipping',
} as const;

export const flattenDeliveryOfferings = (groups?: DeliveryMethodGroup[]): ProductOfferingCoco[] =>
  groups?.flatMap(g => g.deliveryProductOffering ?? []) ?? [];

export const getDeliveryModeForOffering = (
  groups: DeliveryMethodGroup[] | undefined,
  offeringId: string | undefined
): DeliveryModeType =>
  groups?.find(group => group.deliveryProductOffering?.some(offering => offering.id === offeringId))?.id ===
  DELIVERY_GROUP_IDS.INDIRECT
    ? DeliveryModeType.COLLECT_POINT
    : DeliveryModeType.ADDRESS;

export const formatDeliveryPrice = (priceInCents?: number): string => {
  if (priceInCents === undefined || priceInCents === null) {
    return '';
  }
  if (priceInCents === 0) {
    return t.BWTQ(freeMsg);
  }
  return `${(priceInCents / 100).toFixed(2)} €`;
};
